import img1 from "./images/image-product-1.jpg";
import img1TN from "./images/image-product-1-thumbnail.jpg";
import img2 from "./images/image-product-2.jpg";
import img2TN from "./images/image-product-2-thumbnail.jpg";
import img3 from "./images/image-product-3.jpg";
import img3TN from "./images/image-product-3-thumbnail.jpg";
import img4 from "./images/image-product-4.jpg";
import img4TN from "./images/image-product-4-thumbnail.jpg";

export const SLIDER_ITEMS = [
    {
        img: img1,
        thumbnail: img1TN,
        index: 0
    },
    {
        img: img2,
        thumbnail: img2TN,
        index: 1
    },
    {
        img: img3,
        thumbnail: img3TN,
        index: 2
    },
    {
        img: img4,
        thumbnail: img4TN,
        index: 3
    },
];